import PaymentInfoModal from "./paymentInfoModal/paymentInfoModal.vue";
import CardApi from "@/services/api/cardApi";
import BalanceApi from "@/services/api/balanceApi";
import { mapGetters } from "vuex";

const CardApiService = new CardApi(),
  BalanceApiService = new BalanceApi();

export default {
  components: {
    PaymentInfoModal
  },

  data() {
    return {
      buyerData: null,
      loading: false,
      cards: [],
      cardForEdit: null,
      showCreateEditCardModal: false,
      showSelectDifferentCardModal: false,
      replacementCard: null,
      confirmButtonDisabled: true,
      request_started: false,
      alertSettings: {
        title: "Are you sure?",
        text: "Are you sure you want to delete this payment method?",
        showCancelButton: true,
        cancelButtonText: "no",
        confirmButtonText: "yes",
      },
    };
  },
  methods: {
    getCards,
    confirmRemove,
    remove,
    showEditCardModal,
    closeEditCardModal,
    submit,
    onCreditCardChanged,
    handleConfirmClick,
    callReplaceCardAndClearSelectDifferentCardModal,
    setReplacementCardData,
    async handlePayClick() {
      const {data} = await BalanceApiService.getBuyerToken();
      window.balanceSDK.paymentMethod.render(data.token, "#balance-sdk");
    },
    async configureBalanceEvents() {
      await this.getBalanceCards();
      window.balanceSDK.paymentMethod.init({
        allowedPaymentMethods: ["creditCard", "achDebit"],
        onSuccess: async () => {
          try {
            const {data} = await BalanceApiService.getCards();
            this.buyerData = data.existingMethods;
          } finally {
            this.loading = false;
          }
        },
        onError: function(error) {
          console.error("completed with error!", error);
        },
        onClose: async () => {
          console.log("payment method modal closed");
          await this.getBalanceCards();
        },
        onCancel: function() {
          console.log("payment method modal cancelled");
        }
      });
    },
    async handleDeleteCard(payment_id){
      const {value: confirm} = await this.$swal(this.alertSettings);
      if (confirm){
        await BalanceApiService.deletePaymentMethod('card',payment_id);
        await this.getBalanceCards();
      }
    },
    async handleDeleteBank(payment_id){
      const {value: confirm} = await this.$swal(this.alertSettings);
      if (confirm) {
        await BalanceApiService.deletePaymentMethod('bank',payment_id);
        await this.getBalanceCards();
      }
    },
    async getBalanceCards(){
      try {
        const {data} = await BalanceApiService.getCards();
        this.buyerData = data;
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      userContext: "userContext"
    })
  },
  mounted() {

    this.loading = true;

    if (this.userContext) {
      if (this.userContext.balance_id !== null && this.userContext.use_balance) {
        this.configureBalanceEvents();
      } else {
        this.getCards();
      }
    }
  },
  watch: {
    userContext: function() {
      this.configureBalanceEvents();
    }
  }
};

async function getCards() {
  try {
    const { data } = await CardApiService.getStoredCreditCardList();

    this.cards = data;
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
  } finally {
    this.loading = false;
  }
}

function confirmRemove(card) {
  this.$swal({
    title: "Are you sure?",
    text: "Are you sure you want to remove this card information?",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm"
  }).then((confirm) => {
    if (confirm.value) {
      this.$loader.$emit("trigger", true);
      this.remove(card);
    }
  });
}

async function remove(card) {
  const { card_id } = card;
  try {
    await CardApiService.removeCardById(card_id);
    this.$swal("Success", "Payment info successfully removed");
    this.getCards();
  } catch (error) {
    const hasCardConflictError = error.response.data.status_text === "Conflict",
      hasOtherCards = this.cards.length > 1;
    if (hasCardConflictError && hasOtherCards) {
      this.cardForEdit = card;
      this.showSelectDifferentCardModal = true;
    } else {
      this.$swal("Attention", error.response.data.error_message);
    }
  } finally {
    this.$loader.$emit("trigger", false);
  }
}

function showEditCardModal(card) {
  this.cardForEdit = card;
  this.showCreateEditCardModal = true;
}

function closeEditCardModal() {
  this.cardForEdit = null;
  this.showCreateEditCardModal = false;
  this.showSelectDifferentCardModal = false;
}

async function submit(data) {
  try {
    const request = {
      stripe_card_token: data.token,
      old_card_token: data.old_card_token ? data.old_card_token : "",
      first_name: data.firstName,
      last_name: data.lastName
    };

    await CardApiService.updateCard(request);
    this.cardForEdit = null;
    this.$swal("Success", "Card updated successfully");
    this.closeEditCardModal();
    this.getCards();
  } catch (error) {
    this.$refs.paymentInfoModal.request_started = false;
    this.$swal("Attention", error.response.data.error_message);
  }
}

function setReplacementCardData(card) {
  if (card === this.replacementCard) {
    this.confirmButtonDisabled = true;
  } else {
    this.replacementCard = card;
    this.confirmButtonDisabled = false;
  }
}

async function callReplaceCardAndClearSelectDifferentCardModal() {
  this.request_started = true;
  const payload = {
    stripe_card_token: this.replacementCard.value,
    old_card_token: this.cardForEdit.card_id
  };
  try {
    await CardApiService.replaceCard(payload);
    this.$swal("Success", "Payment info successfully removed");
  } catch (error) {
    await this.$swal("Attention", error.response.data.error_message);
  } finally {
    this.showSelectDifferentCardModal = false;
    this.request_started = false;
    await this.getCards();
    this.$loader.$emit("trigger", false);
  }
}

function onCreditCardChanged(card) {
  this.setReplacementCardData(card);
}

function handleConfirmClick() {
  this.callReplaceCardAndClearSelectDifferentCardModal();
}
